import { defineKey as T } from 'ha/i18n';

export const ERROR_MESSAGES = {
  412: T(
    'You cannot take this action right now. Refreshing the page might resolve the issue, if not please reach out to us.',
  ),
  417: T('Payment failed'),
  422: T('Payment method creation failed'),
  400: T('Please propose different dates or a different price'),
  startDate: T(
    'The selected dates are not available according to your calendar. Please check the availability and your minimum rental period',
  ),
  startDateInThePastTenant: T('Start date in the past'),
  startDateBeforeEndDate: T('Start date should be before the end date'),
  startDateInThePastAdvertiser: T(
    'You cannot send a request with dates in the past. Please send a special offer with available dates in the future.',
  ),
  DEFAULT: T('Something went wrong'),
};
